export default {
    path: 'invoice_partner',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/invoicepartner/InvoicePartnerList'),
    meta: {title:'开票管理',cate:'开票中心'},
    children: [
        {
            path: 'detail',
            component: () => import(/* webpackChunkName: "article-create" */ '@/pages/common/invoiceDetails'),
            meta: { title: '申请详情' },
        },
    ]
}